var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar Star",
    clipPath: "url(#clip0_32_9693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-star--calendar-date-day-favorite-like-month-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 5C3.08696 5 2.45107 5.26339 1.98223 5.73223C1.51339 6.20107 1.25 6.83696 1.25 7.5V31.25C1.25 31.913 1.51339 32.5489 1.98223 33.0178C2.45107 33.4866 3.08696 33.75 3.75 33.75H31.25C31.913 33.75 32.5489 33.4866 33.0178 33.0178C33.4866 32.5489 33.75 31.913 33.75 31.25V7.5C33.75 6.83696 33.4866 6.20107 33.0178 5.73223C32.5489 5.26339 31.913 5 31.25 5H26.25",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 1.25V8.75",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.25 1.25V8.75",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.75 5H21.25",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1224 11.6304L20.2124 15.8379C20.2592 15.9445 20.3333 16.0367 20.4273 16.1052C20.5213 16.1737 20.6317 16.2161 20.7474 16.2279L25.3924 16.9329C25.5257 16.9497 25.6514 17.0043 25.7547 17.0901C25.858 17.1759 25.9347 17.2894 25.9757 17.4173C26.0166 17.5452 26.0202 17.6822 25.986 17.8121C25.9518 17.9419 25.8811 18.0593 25.7824 18.1504L22.3524 21.4079C22.3012 21.5055 22.2744 21.614 22.2744 21.7242C22.2744 21.8344 22.3012 21.9429 22.3524 22.0404L23.01 26.6604C23.0382 26.794 23.0271 26.9329 22.978 27.0603C22.9289 27.1877 22.8438 27.298 22.7331 27.378C22.6225 27.4579 22.491 27.504 22.3546 27.5107C22.2182 27.5173 22.0829 27.4842 21.965 27.4154L17.8299 25.2254C17.7231 25.1773 17.6072 25.1524 17.4899 25.1524C17.3727 25.1524 17.2568 25.1773 17.1499 25.2254L13.0149 27.4154C12.8969 27.4831 12.7618 27.5152 12.626 27.5081C12.4901 27.5009 12.3592 27.4547 12.2489 27.375C12.1386 27.2954 12.0536 27.1856 12.0042 27.0588C11.9547 26.9321 11.9428 26.7938 11.9699 26.6604L12.7449 22.0404C12.7788 21.9333 12.7855 21.8195 12.7645 21.7091C12.7436 21.5987 12.6956 21.4952 12.6249 21.4079L9.19995 18.1254C9.10869 18.0335 9.04453 17.9181 9.01453 17.7921C8.98452 17.6661 8.98983 17.5342 9.02987 17.411C9.06991 17.2877 9.14313 17.1779 9.2415 17.0936C9.33986 17.0093 9.45956 16.9537 9.58745 16.9329L14.2324 16.2529C14.3482 16.2411 14.4586 16.1987 14.5526 16.1302C14.6466 16.0617 14.7207 15.9695 14.7674 15.8629L16.8599 11.6554C16.9157 11.5361 17.0038 11.4348 17.1142 11.363C17.2247 11.2912 17.353 11.2518 17.4847 11.2492C17.6164 11.2466 17.7461 11.2809 17.8593 11.3483C17.9725 11.4157 18.062 11.5134 18.1224 11.6304Z",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_9693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.ca152607b832c98d23ab48353d25e05b.svg";
export { ForwardRef as ReactComponent };